import React from 'react';
import {Accept, useDropzone} from 'react-dropzone';
import {useTranslation} from 'react-i18next';
import {FileImageOutlined} from '@ant-design/icons';
import classNames from 'classnames';

interface DropzoneProps {
  multiple?: boolean;
  icon?: JSX.Element;
  className?: string;
  accept?: Accept;
  onDrop: (files: File[]) => void;
}

export const Dropzone: React.FC<DropzoneProps> = ({multiple = false, accept, className, onDrop}) => {
  const {t} = useTranslation();
  const {getRootProps, getInputProps} = useDropzone({
    multiple,
    onDrop,
    accept,
  });

  return (
    <div
      {...getRootProps()}
      className={classNames(
        'flex justify-center mb-1 px-6 pt-6 pb-6 rounded-xl border-2 border-gray border-dashed cursor-pointer',
        className
      )}
    >
      <div className="space-y-1 text-center">
        <FileImageOutlined className="mx-auto text-4xl text-antdBlue" />
        <div className="flex text-sm text-darkGray">
          <p className="pr-1">{t('Drag your file here or')}</p>
          <label
            htmlFor="file-upload"
            className="relative cursor-pointer bg-white rounded-lg font-medium text-indigo-600 hover:text-indigo-500 focus-within:outline-none focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
          >
            <span className="text-antdBlue font-semibold">{t('browse')}</span>
            <input id="file-upload" name="file-upload" {...getInputProps()} />
          </label>
        </div>
      </div>
    </div>
  );
};
